import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Tab, Icon } from 'semantic-ui-react'

import { goodsServiceReceiptPath } from 'routes'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import Approve from '../Shareds/Approve'
import Summary from './Summary'
import Detail from './Detail'
import CommentHistory from './CommentHistory'
import POHistory from './POHistory'
import RequestInformation from '../Shareds/RequestInformation'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import Attachment from '../Shareds/Attachment'
import ActionCommentModal from '../Shareds/ActionCommentModal'
import { 
  MainBodyContent, 
  K2ErrorModal, 
} from 'components'
import { 
  getGRDetail,
  clearGRDetail,
  initializeGR,
  getGRGOAWorkFlowViewMode,
  getGRErrorWorkFlow,
  getSpecialApprovalInfo,
  addSpecialComment
} from 'ducks/goodsServiceReceipt'

const DetailGoodsServiceReceipt = props => {

  const { 
    history,
    valueForm,
    grDetail,
    goaWorkFlow,
    k2workFlowError,
    isDetail = true,
  } = props

  const [showDialogComment, setShowDialogComment] = React.useState(false)

  React.useEffect(() => {
    const { match } = props
    window.scrollTo(0,0)
    props.initializeGR(isDetail)
    if (match && match.params && match.params.grId) {
      props.getGRDetail(match.params.grId, history)
    }
    return (() => {
      props.clearGRDetail()
    })
  },[])

  React.useEffect(() => {
    if (valueForm&&valueForm.specialApprovalId) {
      props.getSpecialApprovalInfo(valueForm.specialApprovalId)
    }
  },[valueForm&&valueForm.specialApprovalId])

  React.useEffect(() => {
    if (valueForm&&valueForm.status&&valueForm.status!==0) {
      props.getGRErrorWorkFlow(valueForm.procInstId, valueForm.subProcInstId)
    }
  },[valueForm&&valueForm.status])

  React.useEffect(() => {
    if(props.grId){
      props.getGRGOAWorkFlowViewMode(props.grId)
    }
  },[props.grId])

  const panes = [
    { menuItem: 'Summary', render: () => <Summary /> },
    { menuItem: 'Detail', render: () => <Detail change={props.change}/> },
    { menuItem: 'Attachment', render: () => <Attachment /> },
    { menuItem: 'Comment History', render: () => <CommentHistory 
      accessoriesHeader={valueForm.canComment?
        <Button 
          type='button'
          content='Add Comment' 
          color='blue' 
          icon='plus'
          style={{ marginRight: '0.3125rem' }}
          onClick={()=>{
            setShowDialogComment(true)
          }}
        />
      :null}/>
    },
    { menuItem: 'Purchase Order History', render: () => <POHistory /> },
  ]

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
    .then(() => {
      if (!valueForm.actionComment) {
        scrollToFirstValidateFailElement({actionComment:'Required!'})
        throw new SubmissionError({actionComment:'Required!'})
      }else{
        props.addSpecialComment(valueForm.id,{
          comment:valueForm.actionComment,
          file:valueForm.attachFile
        },history)
        setShowDialogComment(false)
      }
    })
  } 

  return (
    <MainBodyContent
      headerTitle={<React.Fragment>{valueForm&&valueForm.isSpecialCreditTerm&&<Icon size='tiny' name='star' color='yellow'/>}{`Goods Service Receipt - ${grDetail.data?grDetail.data.documentNumber?`#${grDetail.data.documentNumber}`:'':''}`}</React.Fragment>}
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: 'GR',
              content: 'Goods Service Receipt',
              link: true,
              onClick: () => history.push(goodsServiceReceiptPath),
            },
            { key: 'GRDetail', content: 'Detail', active: true },
          ]}
        />
      }
      accessoriesHeader={
        valueForm&&valueForm.status==4?
        <Button 
          basic  
          circular 
          type='button'
          onClick={()=>window.open(valueForm.urlPrintFormGr||'',"_blank")} 
          content='GR Print Form' 
          labelPosition='right'
          icon='file alternate' />:null
      }
      accessoriesHeaderLeft={
        k2workFlowError.isError&&
          <K2ErrorModal checkK2Error={k2workFlowError}/>  
      }
    >
      {Object.keys(grDetail.data).length?<DocumentStep documentDetail={grDetail.data} approvers={goaWorkFlow.data} />:null}
      <RequestInformation/>
      {valueForm&&(valueForm.sn&&valueForm.status!=6)?
      <Approve history={history} handleSubmit={props.handleSubmit} grDetail={grDetail.data}/>:null}

      <Tab style={{flex:1,marginTop:'1rem'}} menu={{ attached: false }} panes={panes} />
      {showDialogComment&&<ActionCommentModal submit={props.handleSubmit(()=>onSubmitForm())} setShowDialogComment={setShowDialogComment} actionName={'addComment'} requireComment includeFile showMessage={false}/>}
    </MainBodyContent>
  )

}

const mapStateToProps = (state, props) => {
  let grDetail = state.gr.grDetail
  return ({
    initialValues: {
      ...grDetail.data,
      vendor:grDetail.data.vendorCode?`${grDetail.data.vendorCode} | ${grDetail.data.vendorFullName}`:'',
      forPeriod:grDetail.data.forPeriod||'-',
      totalPeriod:grDetail.data.totalPeriod||'-',
      otherName1:grDetail.data.otherName1||'-',
      otherName2:grDetail.data.otherName2||'-',
      otherName3:grDetail.data.otherName3||'-',
      deductRetentionRate:grDetail.data.deductRetentionRate||null
    },
    grId: grDetail.data.id,
    grDetail,
    goaWorkFlow: state.gr.goaWorkFlow,
    k2workFlowError: state.gr.k2workFlowError,
    valueForm: getFormValues('formGR')(state),
  })
}
const mapDispatchToProps = {
  getGRDetail,
  clearGRDetail,
  initializeGR,
  getGRGOAWorkFlowViewMode,
  getGRErrorWorkFlow,
  getSpecialApprovalInfo,
  addSpecialComment
}

const contForm = reduxForm({
  form: 'formGR',
  enableReinitialize: true,
})(DetailGoodsServiceReceipt)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
